import { Component, Inject, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedConstants } from '../shared.constants';

@Component({
  selector: 'app-community-care-confirmation-dialog',
  templateUrl: './community-care-confirmation-dialog.component.html',
  styleUrls: ['./community-care-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class CommunityCareConfirmationDialogComponent {

  public givingStrategyUrl = SharedConstants.givingStrategyUrl;
  public mailToUrl = 'mailto:prsupport@chick-fil-a.com'
  public operatingStandardUrl = SharedConstants.operatingStandardUrl;
  public confirmationButton = SharedConstants.CCEConfirmationButton;
  public goBackButton = SharedConstants.CCEGoBackButton;

  constructor(
      @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
      public dialogRef: MatDialogRef<CommunityCareConfirmationDialogComponent>) {}

  public closeDialog(shouldSend: boolean) {
    this.dialogRef.close(shouldSend);
  }
}
